"use strict";

define('rs/models/decision.category',['rs/models/abstract', 'rs/helper'], function (AbstractModel, SponsorModel, helper) {
  var DecisionCategory = AbstractModel.extend({
    serverProperties: ['id', 'label', 'description', 'version', 'activityDate', 'updateUserAuthId']
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#category/:decisionId(/:decisionType)': function getCategory_DecisionId_DecisionType(data) {
        return DecisionCategory.models(data);
      }
    },
    requestCategories: function requestCategories(decisionId, decisionType) {
      return this.get('category/' + decisionId + (decisionType ? '/' + decisionType : ''));
    }
  });
  return DecisionCategory;
});

